import React, { useState } from "react";
import Typical from "react-typical";
import axios from "axios";
import { toast } from "react-toastify";

import imgBack from "../../../src/images/mailz.jpeg";
import load1 from "../../../src/images/load2.gif";
import dockerIcon from "../../../src/img/MyIcons/docker-icon1.png"
//Import other images similarly

import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import Footer from "../../PortfolioContainer/Footer/Footer";
import "./ContactMe.css";

export default function ContactMe(props) {

  //Smooth scroll and fadein effects
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);

  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };
  console.log(name);
  const submitForm = async (e) => {
    e.preventDefault();
    try {
      let data = {
        name,
        email,
        message,
      };
      setBool(true);
      const res = await axios.post(`/contact`, data);
      if (name.length === 0 || email.length === 0 || message.length === 0) {
        setBanner(res.data.msg);
        toast.error(res.data.msg);
        setBool(false);
      } else if (res.status === 200) {
        setBanner(res.data.msg);
        toast.success(res.data.msg);
        setBool(false);

        setName("");
        setEmail("");
        setMessage("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main-container fade-in" id={props.id || ""}>
      <ScreenHeading subHeading={"Interested in working together? You can get to me on various platforms."} title={"Contact Me"} />
      <div className="central-form">
        <div className="col">
          <h2 className="title">
            <Typical
              loop={Infinity}
              steps={[
                "Get In Touch. 🤝✍", 2000,
                "Let's get your job done ✅", 2000
              ]}
            />
          </h2>{" "}
          <h3 className="contact-handle">
            @florenceomoruyi
          </h3>{" "}
          <div className="contact-info">
            <a href='https://www.linkedin.com/in/florence-omoruyi-0ab9b119a/'>
                  <i class="fa fa-linkedin fa-2x"></i>
            </a>
            <a href='https://github.com/Florence-InLineOfSight'>
              <i class="fa fa-github fa-2x"></i>
            </a>             
            <a href='https://hub.docker.com/repository/docker/florenceomoruyi/php-web-app1/general'>
              <img src={dockerIcon} alt="no internet connection"></img>
            </a>
            <a href='twitter.com'>
              <i class="fa fa-twitter fa-2x"></i>
            </a>
            <a href='facebook.com'>
              <i class="fa fa-facebook fa-2x"></i>
            </a>
          </div>
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>Email me directly! 📧</h4>
            <img src={imgBack} alt="Image not found" />
          </div>
          <form onSubmit={submitForm}>
            <p>{banner}</p>
            <label htmlFor="name">Name</label>
            <input type="text" onChange={handleName} value={name} />

            <label htmlFor="email">Email</label>
            <input type="email" onChange={handleEmail} value={email} />

            <label htmlFor="message">Message</label>
            <textarea type="text" onChange={handleMessage} value={message} />

            <div className="send-btn">
              <button type="submit">
                Send
                <i className="fa fa-paper-plane" />
                {bool ? (
                  <b className="load">
                    <img src={load1} alt="Image not responding" />
                  </b>
                ) : (
                  ""
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <Footer />

    </div>
  );
}